<template>
    <div>
        <div v-if="fileInfo.type.indexOf('icon_multiple')>-1">
            <img v-if="fileInfo.type.indexOf('web_pic')>-1" src="../../../static/images/tupian.png">
            <img v-if="fileInfo.type.indexOf('web_file')>-1" src="../../../static/images/wenjian.png">
            <input v-if="fileInfo.type.indexOf('web_pic')>-1" type="file" :class="fileInfo.className" multiple name="file" ref="inputer" @change="beforeUpload" accept="image/jpg,image/jpeg,image/png,image/PNG">
            <input v-if="fileInfo.type.indexOf('web_file')>-1" type="file" :class="fileInfo.className" multiple name="file" ref="inputer" @change="beforeUpload">
            <input v-if="fileInfo.type.indexOf('h5')>-1" type="file" :class="fileInfo.className" multiple name="file" ref="inputer" @change="beforeUpload">
        </div>
    </div>
</template>
<script>
    import chatDataCenter from "../../jsSdk/chatDataCenter";
    import Exif from '../../../static/js/exif'
    import common from "../../utils/common";

    export default {
        props:['fileInfo'],
        data() {
            return {
                messageId:'',
                messageType:'',
            };
        },
        methods: {
            //上传文件之前
            beforeUpload(event) {
                let files = this.$refs.inputer.files;
                this.fileInfo.flag=false;
                var _this=this;
                if(files.length>1){
                    this.$messageBox.Error({message:"一次只能上传一个文件!",duration:3000});
                    return false;
                }
                for (var i=0;i<files.length;i++) {
                    var file=files[i]
                     if(this.fileInfo.type.indexOf('pic')>-1){
                        var isJPG = file.type.indexOf('image')>-1;
                        var isLt2M = file.size / 1024 / 1024 < 10;
                        if (!isJPG) {
                            this.$messageBox.Error({message:"请选择图片!",duration:3000});
                            return false;
                        }
                        if (!isLt2M) {
                            this.$messageBox.Error({message:"图片大小不能超过 10MB!",duration:3000});
                            return false;
                        }
                        if (isJPG && isLt2M){
                            _this.messageId=chatDataCenter.chatRoom.sendMessageInfoBeforeUpload("img");
                            _this.messageType='I';
                            _this.emptyFile()
                            if (common.isIOS()) { //移动端,或点击显示
                                this.imgPreview(file)
                            }else {
                                this.uploadFile(file)
                            }
                        }
                    }else if(this.fileInfo.type.indexOf('video')>-1){
                        var isVideo = file.type.indexOf('video')>-1;
                        var isLt2M = file.size / 1024 / 1024 < 50;
                        if (!isVideo) {
                            this.$messageBox.Error({message:"请选择视频!",duration:3000});
                            return false;
                        }
                        if (!isLt2M) {
                            this.$messageBox.Error({message:"视频大小不能超过 50MB!",duration:3000});
                            return false;
                        }
                        if (isVideo && isLt2M){
                            _this.messageId=chatDataCenter.chatRoom.sendMessageInfoBeforeUpload("video");
                            _this.messageType='V';
                            _this.emptyFile()
                            this.uploadFile(file)
                        }
                    }else {
                        var isLt10M = file.size / 1024 / 1024 < 50;
                        if (!isLt10M) {
                            this.$messageBox.Error({message:"文件大小不能超过 50MB!",duration:3000});
                            return false;
                        }
                        if (isLt10M){
                            if(file.type.indexOf('image')>-1){
                                _this.messageId=chatDataCenter.chatRoom.sendMessageInfoBeforeUpload("img");
                                _this.messageType='I';
                            }else if(file.type.indexOf('video')>-1){
                                _this.messageId=chatDataCenter.chatRoom.sendMessageInfoBeforeUpload("video");
                                _this.messageType='V';
                            }else {
                                _this.messageId=chatDataCenter.chatRoom.sendMessageInfoBeforeUpload("file");
                                _this.messageType='F';
                            }
                            _this.emptyFile()
                            if (file.type.indexOf('image')>-1&&common.isIOS()) { //移动端,或点击显示
                                this.imgPreview(file)
                            }else {
                                this.uploadFile(file)
                            }
                        }
                    }
                }
            },
            emptyFile:function () {
               var element= document.getElementsByName('file');
               for (var i=0;i<element.length;i++){
                   document.getElementsByName('file')[i].value=null
               }
            },
            uploadFile(file) {
                var _this=this;
                var formData = new FormData();
                formData.append("groupName", _this.$config.group1);
                formData.append("multipartFile",file);
                console.log(file)
                _this.$axiosService.postFile('minio/uploadFile',formData, response => {
                    if(response.code==0){
                        _this.fileInfo.flag=true;
                        if(_this.fileInfo.type.indexOf('icon')>-1){
                            _this.fileInfo.url=response.data.fullPath
                            _this.fileInfo.name=file.name
                            _this.fileInfo.size=file.size
                            _this.fileInfo.messageId=_this.messageId;
                            _this.fileInfo.messageType= _this.messageType;
                            _this.$emit('fromUploadFilePage',_this.fileInfo);
                        }
                    }else {
                        var message=chatDataCenter.chatRoom.getMessageByMessageId(_this.messageId);
                        message.sendFileStatus=2;
                        message.messageStatus=-1;
                        chatDataCenter.chatRoom.setMessageByMessageId(_this.messageId,message);
                        this.$messageBox.Error({message:response.msg,duration:3000});
                    }

                });
            },
            imgPreview (file) {
                let self = this;
                let Orientation;
                //去获取拍照时的信息，解决拍出来的照片旋转问题
                Exif.getData(file, function(){
                    Orientation = Exif.getTag(this, 'Orientation');
                });
                // 看支持不支持FileReader
                if (!file || !window.FileReader) return;

                if (/^image/.test(file.type)) {
                    // 创建一个reader
                    let reader = new FileReader();
                    // 将图片2将转成 base64 格式
                    reader.readAsDataURL(file);
                    // 读取成功后的回调
                    reader.onloadend = function () {
                        let result = this.result;
                        let img = new Image();
                        img.src = result;
                        //判断图片是否大于100K,是就直接上传，反之压缩图片
                        if (this.result.length <= (100 * 1024)) {
                            let data  = this.result;
                            let file  = self.convertBase64Url(data);
                            self.uploadFile( file);
                        }else {
                            img.onload = function () {
                                let data = self.compress(img,Orientation);
                                let file  = self.convertBase64Url(data);
                                self.uploadFile( file);
                            }
                        }
                    }
                }
            },
            rotateImg (img, direction,canvas) {
                //最小与最大旋转方向，图片旋转4次后回到原方向
                const min_step = 0;
                const max_step = 3;
                if (img == null)return;
                //img的高度和宽度不能在img元素隐藏后获取，否则会出错
                let height = img.height;
                let width = img.width;
                let step = 2;
                if (step == null) {
                    step = min_step;
                }
                if (direction == 'right') {
                    step++;
                    //旋转到原位置，即超过最大值
                    step > max_step && (step = min_step);
                } else {
                    step--;
                    step < min_step && (step = max_step);
                }
                //旋转角度以弧度值为参数
                let degree = step * 90 * Math.PI / 180;
                let ctx = canvas.getContext('2d');
                switch (step) {
                    case 0:
                        canvas.width = width;
                        canvas.height = height;
                        ctx.drawImage(img, 0, 0);
                        break;
                    case 1:
                        canvas.width = height;
                        canvas.height = width;
                        ctx.rotate(degree);
                        ctx.drawImage(img, 0, -height);
                        break;
                    case 2:
                        canvas.width = width;
                        canvas.height = height;
                        ctx.rotate(degree);
                        ctx.drawImage(img, -width, -height);
                        break;
                    case 3:
                        canvas.width = height;
                        canvas.height = width;
                        ctx.rotate(degree);
                        ctx.drawImage(img, -width, 0);
                        break;
                }
            },
            compress(img,Orientation) {
                let canvas = document.createElement("canvas");
                let ctx = canvas.getContext('2d');
                //瓦片canvas
                let tCanvas = document.createElement("canvas");
                let tctx = tCanvas.getContext("2d");
                let initSize = img.src.length;
                let width = img.width;
                let height = img.height;
                //如果图片大于四百万像素，计算压缩比并将大小压至400万以下
                let ratio;
                if ((ratio = width * height / 4000000) > 1) {
                    console.log("大于400万像素")
                    ratio = Math.sqrt(ratio);
                    width /= ratio;
                    height /= ratio;
                } else {
                    ratio = 1;
                }
                canvas.width = width;
                canvas.height = height;
                //    铺底色
                ctx.fillStyle = "#fff";
                ctx.fillRect(0, 0, canvas.width, canvas.height);
                //如果图片像素大于100万则使用瓦片绘制
                let count;
                if ((count = width * height / 1000000) > 1) {
                    console.log("超过100W像素");
                    count = ~~(Math.sqrt(count) + 1); //计算要分成多少块瓦片
                    //      计算每块瓦片的宽和高
                    let nw = ~~(width / count);
                    let nh = ~~(height / count);
                    tCanvas.width = nw;
                    tCanvas.height = nh;
                    for (let i = 0; i < count; i++) {
                        for (let j = 0; j < count; j++) {
                            tctx.drawImage(img, i * nw * ratio, j * nh * ratio, nw * ratio, nh * ratio, 0, 0, nw, nh);
                            ctx.drawImage(tCanvas, i * nw, j * nh, nw, nh);
                        }
                    }
                } else {
                    ctx.drawImage(img, 0, 0, width, height);
                }
                //修复ios上传图片的时候 被旋转的问题
                if(Orientation != "" && Orientation != 1){
                    switch(Orientation){
                        case 6://需要顺时针（向左）90度旋转
                            this.rotateImg(img,'left',canvas);
                            break;
                        case 8://需要逆时针（向右）90度旋转
                            this.rotateImg(img,'right',canvas);
                            break;
                        case 3://需要180度旋转
                            this.rotateImg(img,'right',canvas);//转两次
                            this.rotateImg(img,'right',canvas);
                            break;
                    }
                }
                //进行最小压缩
                let ndata = canvas.toDataURL('image/jpeg', 0.1);
                console.log('压缩前：' + initSize);
                console.log('压缩后：' + ndata.length);
                console.log('压缩率：' + ~~(100 * (initSize - ndata.length) / initSize) + "%");
                tCanvas.width = tCanvas.height = canvas.width = canvas.height = 0;
                return ndata;
            },
            //此函数是为了转化base64的值，用于传给后台
            convertBase64Url:function (data){
                //获取canvas中的图片信息
                //window.atob方法将其中的base64格式的图片转换成二进制字符串；若将转换后的值直接赋值给Blob会报错，需Uint8Array转换：最后创建Blob对象；
                var _data = window.atob(data.split(",")[1]);
                //如果不用ArrayBuffer,发送给服务器的图片格式是[object Uint8Array],上传失败...
                var buffer = new ArrayBuffer(_data.length);
                var _buffer = new Uint8Array(buffer);
                for(var i = 0; i < _data.length; i++) {
                    _buffer[i] = _data.charCodeAt(i);
                }
                var blob;
                var Builder = window.BlobBuilder || window.WebKitBlobBuilder || window.MozBlobBuilder || window.MSBlobBuilder;;
                if(Builder) {
                    var builder = new Builder();
                    builder.append(_buffer);
                    blob = builder.getBlob('image/jpeg');
                } else {
                    blob = new window.Blob([_buffer], { type: 'image/jpeg'});
                }
                return blob;
            }
        },
    }
</script>

<style>


</style>

<style scoped>
    .fujian-btn{
        color: #4192ed;
        font-size: 13px;
        margin-top: 0px;
    }
    a{
        outline: none;
    }
    .bottom-file{
        position: absolute !important;
        left: 5px !important;
        top: 11px !important;
        width: 90px !important;
        height: 100px !important;
        font-size: 0px !important;
        outline: none !important;
        opacity: 0 !important;
        -webkit-opacity: 0 !important;
        -moz-opacity: 0 !important;
        -ms-opacity: 0 !important;
        -khtml-opacity: 0 !important;
        cursor: pointer !important;
        filter: alpha(opacity=0) !important; /* IE 8 */
        zoom: 1;
    }

</style>
